import {GCPortalkarteBaseClass} from "./class_portalkarte_base";
import {GCPortalkarteEditClass} from "./class_portalkarte_edit";

export class GCPortalkarteEditbarClass extends GCPortalkarteBaseClass {

    private portalkarte:GCPortalkarteEditClass;
    private map: any;
    private trackingLayer: any;
    private editbar: any;
    private wktDialog: any;

    /**
     * ID des Timers zur Verzögerung des Speicherns
     * @private
     */
    private delaySaveTimer: number;

    /**
     * Interner Zähle bei neu angelegten Feature-Objekten
     * @private
     */
    private newFeatureIndex: number;

    /**
     *
     */
    public constructor(portalkarte: GCPortalkarteEditClass, trackingLayer: any) {
        super();
        this.portalkarte = portalkarte;
        this.map = portalkarte.getMap();
        this.trackingLayer = trackingLayer;
        this.newFeatureIndex = 0;
        this.delaySaveTimer = 0;
        this.wktDialog = null;
    }

    public decodeHtml(html: string) {
        let txt = document.createElement("textarea");
        txt.innerHTML = html;
        return txt.value;
    }

    public encodeHTMLEntities(text: string) {
        const code = {
            ' ': '&nbsp;',
            '¢': '&cent;',
            '£': '&pound;',
            '¥': '&yen;',
            '€': '&euro;',
            '©': '&copy;',
            '®': '&reg;',
            '<': '&lt;',
            '>': '&gt;',
            '"': '&quot;',
            '&': '&amp;',
            '\'': '&apos;',
            'ü': '&uuml;',
            'ä': '&auml;',
            'ö': '&ouml;',
            'Ü': '&Uuml;',
            'Ä': '&Auml;',
            'Ö': '&Ouml;',
            'ß': '&szlig;'
        };
        return text.replace(/[\u00A0-\u9999<>&\''\""]/gm, (i) => typeof code[i] !== "undefined" ? code[i] : '_');
    }

    /**
     *
     * @param _interactions
     */
    public activateEditBar(_interactions: any = {}) {
        let instance = this.portalkarte;
        let self = this;

        if (!instance.isEditable())
        {
            return null;
        }

        // Interactions
        let interactions: any = {};
        this.jquery.extend(interactions, _interactions);
        let trackingSource = this.trackingLayer.getSource();

        // Menubar einrichten und mit der Karte verbinden
        let mainbar = new this.ol.control.Bar();
        this.map.addControl(mainbar);

        // EditBar einrichten und mit der Menubar verbinden
        this.editbar = new this.ol.control.EditBar({
            source: trackingSource,
            interactions: interactions,
            autoDeactivate: true,
            toggleOne: true,	// one control active at the same time
            group: false			// group controls together
        });

        // @see https://github.com/Viglino/ol-ext/issues/725
        let element1 = this.editbar.getActiveControls()[0];
        // Remove autoActivate option
        element1.set('autoActivate', false);
        // De-activate it
        element1.setActive(false);
        // -------------------------------------------------

        mainbar.addControl(this.editbar);

        // ---
        // Tooltips hinzufügen
        let tooltip = new this.ol.Overlay.Tooltip();
        this.map.addOverlay(tooltip);

        this.editbar.getInteraction('Select').on('select', function (e) {
            if (this.getFeatures().getLength()) {
                tooltip.setInfo('Geometrie anklicken und bearbeiten');
            } else tooltip.setInfo();
        });
        this.editbar.getInteraction('Select').on('change:active', function (e) {
            tooltip.setInfo('');
        });

        // Wenn Interaktion "ImportWKT" gesetzt ist, dann diese auch erzeugen
        if (interactions && interactions.ImportWKT) {
            let import_wkt = new this.ol.control.Toggle(
                {
                    className:    'ol-importwkt',
                    title:        interactions.ImportWKT.title,
                    name:         'ImportWKT',
                    html:         '<i class="icon icon-database-insert"></i>',
                    autoActivate: false,
                    onToggle:  function () {
                        self.openWKTImportDialog();
                    }
                });
            this.editbar.addControl(import_wkt);
        }


        // Spezieller Button für Edit URL (am Feature)
        let select = this.editbar.getControlsByName('Select');
        if (select && this.portalkarte.isEditMeta())
        {
            let selectCtrl  = select[0];
            let self        = this.editbar;

            let edit_url = new this.ol.control.Button(
                {
                    className: 'ol-editurl',
                    title: 'URL zur ausgewählten Geometrie setzen',
                    name: 'EditUrl',
                    html:'<i class="icon icon-circle"></i>',
                    autoActivate: true,
                    handleClick: function() {
                        self.dispatchEvent({
                            type: 'url',
                            features: selectCtrl.getInteraction().getFeatures()
                        });
                    }
                });
            selectCtrl.getSubBar().addControl(edit_url)
        }



        this.editbar.getInteraction('ModifySelect').on('modifystart', function (e) {
            if (e.features.length === 1) tooltip.setFeature(e.features[0]);
        });
        this.editbar.getInteraction('ModifySelect').on('modifyend', function (e) {
            tooltip.setFeature();
        });

        if (this.editbar.getInteraction('DrawPoint')) {
            this.editbar.getInteraction('DrawPoint').on('change:active', function (e) {
                tooltip.setInfo(e.oldValue ? '' : 'Klick auf die Karte setzt neuen Punkt');
            });

            this.editbar.getInteraction('DrawPoint').on('drawend', function (e) {
                if (instance.isEditMeta())  GCPortalkarteEditClass.createFeatureMetadata(e, 'Point', 'Neuer Punkt', ++self.newFeatureIndex)
            });
        }

        // Umbenennung verschiedener Elemente
        if (this.editbar.getControlsByName('DrawLine')) {
            let control = this.editbar.getControlsByName('DrawLine');
            if (Array.isArray(control) && control.length)
            {
                let subbar = control[0].getSubBar().getControls();
                if (Array.isArray(subbar) && subbar.length >= 2)
                {
                    subbar[0].setTitle('Lösche letzten Punkt.');
                    subbar[0].setHtml('<i class="icon icon-undo"></i>');

                    subbar[1].setTitle('Zeichnung abschließen.');
                    subbar[1].setHtml('<i class="icon icon-finish"></i>');
                }
            }
        }

        if (this.editbar.getControlsByName('DrawPolygon')) {
            let control = this.editbar.getControlsByName('DrawPolygon');
            if (Array.isArray(control) && control.length)
            {
                let subbar = control[0].getSubBar().getControls();
                if (Array.isArray(subbar) && subbar.length >= 2)
                {
                    subbar[0].setTitle('Lösche letzten Punkt.');
                    subbar[0].setHtml('<i class="icon icon-undo"></i>');

                    subbar[1].setTitle('Zeichnung abschließen.');
                    subbar[1].setHtml('<i class="icon icon-finish"></i>');
                }
            }
        }

        if (this.editbar.getInteraction('DrawLine')) {
            this.editbar.getInteraction('DrawLine').on(['change:active', 'drawend'], function (e) {
                tooltip.setFeature();
                tooltip.setInfo(e.oldValue ? '' : 'Klick auf Karte startet neue Linie');
            });
            this.editbar.getInteraction('DrawLine').on('drawstart', function (e) {
                tooltip.setFeature(e.feature);
                tooltip.setInfo('Klick auf Karte führt Linie weiter (Doppelklick für Ende)');
            });
            this.editbar.getInteraction('DrawLine').on('drawend', function (e) {
                if (instance.isEditMeta())  GCPortalkarteEditClass.createFeatureMetadata(e, 'Line', 'Neue Linie', ++self.newFeatureIndex)
            });
        }


        if (this.editbar.getInteraction('DrawPolygon')) {
            this.editbar.getInteraction('DrawPolygon').on('drawstart', function (e) {
                tooltip.setFeature(e.feature);
                tooltip.setInfo('Klick auf Karte startet neues Polygon ...');
            });
            this.editbar.getInteraction('DrawPolygon').on(['change:active', 'drawend'], function (e) {
                tooltip.setFeature();
                tooltip.setInfo(e.oldValue ? '' : 'Klick auf Karte führt Polygon weiter (Doppelklick für Ende)');
            });
            this.editbar.getInteraction('DrawPolygon').on('drawend', function (e) {
                if (instance.isEditMeta())  GCPortalkarteEditClass.createFeatureMetadata(e, 'Polygon', 'Neues Polygon', ++self.newFeatureIndex)
            });
        }

        if (this.editbar.getInteraction('DrawHole')) {
            this.editbar.getInteraction('DrawHole').on('drawstart', function (e) {
                tooltip.setFeature(e.feature);
                tooltip.setInfo('Click to continue drawing hole...');
            });
            this.editbar.getInteraction('DrawHole').on(['change:active', 'drawend'], function (e) {
                tooltip.setFeature();
                tooltip.setInfo(e.oldValue ? '' : 'Click polygon to start drawing hole...');
            });
        }

        if (this.editbar.getInteraction('DrawRegular')) {

            // console.log(this.editbar.getInteraction('DrawRegular'));
            // let select = this.editbar.getControlsByName('Select')[0].getSubBar().getControlsByName('SetUrl')[0];
            // console.log(select);

           // this.editbar.getInteraction('DrawRegular').setDis

            this.editbar.getInteraction('DrawRegular').on('drawstart', function (e) {
                tooltip.setFeature(e.feature);
                tooltip.setInfo('Klick auf die Karte beendet das Zeichnen (Umschalt-Taste gedrückt halten für gleichlange Seiten)');
            });
            this.editbar.getInteraction('DrawRegular').on(['change:active', 'drawend'], function (e) {
                tooltip.setFeature();
                tooltip.setInfo(e.oldValue ? '' : 'Klick auf Karte startet neues reguläres Polygon');
            });

            this.editbar.getInteraction('DrawRegular').on('drawend', function (e) {
                if (instance.isEditMeta()) GCPortalkarteEditClass.createFeatureMetadata(e, 'Regular', 'Neues Regulär', ++self.newFeatureIndex)
            });
        }


        this.editbar.on('info', function (e) {
            //console.log('e.features.length = ' + e.features.getLength());
            if (e.features.getLength() == 1) {
                let oTitle = self.decodeHtml(e.features.item(0).get('title'));
                let nTitle = prompt('Titel ändern', oTitle);
                if (nTitle !== null) {
                    nTitle = self.encodeHTMLEntities(nTitle);
                    e.features.item(0).set('title', nTitle);
                    instance.saveData();
                }
            }
        });

        this.editbar.on('url', function (e) {
            //console.log('e.features.length = ' + e.features.getLength());
            if (e.features.getLength() == 1) {
                let url = '';
                let flexml_geom = e.features.item(0).get('flexml_geom');
                if (flexml_geom && flexml_geom.url)
                {
                    url = flexml_geom.url;
                }

                //instance.openEditDialog();
                let oUrl = self.decodeHtml(url);
                let nValue = prompt('URL setzen', oUrl);
                if (nValue !== null) {
                    nValue = self.encodeHTMLEntities(nValue);
                    if (flexml_geom)
                    {
                        flexml_geom.url = nValue;
                    }
                    else
                    {
                        flexml_geom = {url: nValue};
                    }
                    e.features.item(0).set('flexml_geom', flexml_geom);
                    instance.saveData();
                }
            }
        });


        // ---

        let touchi = new this.ol.interaction.LongTouch(
            {
                delay: 500,
                handleLongTouchEvent: function(e)
                {
                    if (instance.isAddFeaturePossible()) {
                        let f = new self.ol.Feature(new self.ol.geom.Point(e.coordinate));
                        instance.getTrackingLayer().getSource().addFeature(f);
                        GCPortalkarteEditbarClass.pulseFeature(instance.getMap(), e.coordinate);
                        setTimeout(function () {
                            GCPortalkarteEditbarClass.pulseFeature(instance.getMap(), e.coordinate);
                        }, 400);
                    } else {
                        self.setFeatureButtonState(false);
                    }
                    //$(".options div").text(vector.getSource().getFeatures().length+" features added!");
                }
            });
        touchi.set('interaction_type','longtouch');
        this.map.addInteraction(touchi);

        // ---


        trackingSource.on('featuresloadend', function (f) {
            //console.log('EVENT ----------------------------');
            //console.log(f);
        });

        trackingSource.on('addfeature', function (f) {
            //console.log('EVENT ----------------------------');
            //console.log(f);
            instance.saveData();
            self.checkFeatureButtonState();
        });

        trackingSource.on('changefeature', function (f) {
            if (self.delaySaveTimer) clearTimeout(self.delaySaveTimer);
            // @ts-ignore
            self.delaySaveTimer = setTimeout(instance.saveData, 1000, instance);
        });

        trackingSource.on('removefeature', function (f) {
            //console.log('EVENT ----------------------------');
            //console.log(f);
            instance.saveData();
            self.checkFeatureButtonState();
        });

        this.checkFeatureButtonState();
        instance.setZoomToExtentState();
        return this.editbar;
    }

    private getWKTImportDialogContent()
    {
        let cnt = document.getElementById('wktdialog_' + this.portalkarte.getTargetId());
        if (cnt)
        {
            return cnt.innerHTML;
        }
        else
        {
            return '';
        }
    }

    /**
     * Erzeugt und öffnet einen Dialog für die Eingabe eines WKT
     * @private
     */
    private openWKTImportDialog()
    {
        let instance = this.portalkarte;
        let self                         = this;

        if (!this.wktDialog) {
            // Dialog erzeugen
            this.wktDialog = new this.ol.control.Dialog({
                content:    this.getWKTImportDialogContent(),
                className:  "wktdialog",
                //fullscreen: true,
                //zoom:       true,
                buttons:    {
                    submit: 'Übernehmen',
                    cancel: 'Verwerfen'
                }
            });
            // Klick-Ereignis behandeln
            this.wktDialog.on('button', function (e) {
                if (e.button === 'submit') {
                    let wkt         = e.inputs['wkt'].value;
                    let projection  = e.inputs['projection'].value;
                    let wkttitle    = e.inputs['wkttitle'].value;

                    if (wkt && projection) {
                        const format = new self.ol.format.WKT();
                        try {
                            const feature = format.readFeature(wkt, {
                                dataProjection:    projection,
                                featureProjection: instance.getViewProjection(),
                            });
                            let ntitle = self.encodeHTMLEntities(wkttitle ? wkttitle : 'Importierte WKT-Geometrie ' + ++self.newFeatureIndex);
                            feature.set('title', ntitle);
                            instance.getTrackingLayer().getSource().addFeature(feature);
                            instance.redrawExtent();

                            e.inputs['projection'].value = 'EPSG:4326';
                            e.inputs['wkt'].value = '';
                            e.inputs['wkttitle'].value = '';
                        }
                        catch (e) {
                            alert('WKT konnte nicht korrekt gelesen werden. Bitte prüfen Sie den WKT und die Projektion.')
                            console.error('WKT konnte nicht korrekt gelesen werden.');
                            console.error(wkt);
                            self.wktDialog.show();
                        }
                    }
                }
                else if (e.button === 'cancel')
                {
                    e.inputs['projection'].value = 'EPSG:4326';
                    e.inputs['wkt'].value = '';
                    e.inputs['wkttitle'].value = '';
                }
            });

            instance.getMap().addControl(this.wktDialog);
        }
        this.wktDialog.show();
    }

    /**
     * Ermittelt eine Liste von Controls an Hand einer CSS-Klasse
     * @param {string} cname
     * @private
     */
    private getControlsByClass(cname: string) {
        let controls = this.editbar.getControls();
        return controls.filter(
            function (control) {
                return (control.element && control.element.classList.contains(cname));
            }
        );
    };

    /**
     * Setzt den Status für die Bearbeitungselemente auf Enable oder Disable
     * @param {boolean} state
     * @private
     */
    private setFeatureButtonState(state: boolean) {
        let filtered = null;
        let names = ['ol-drawpoint', 'ol-drawline', 'ol-drawpolygon', 'ol-drawregular','ol-importwkt'];
        for (let i = 0; i < names.length; i++) {
            filtered = this.getControlsByClass(names[i]);
            if (filtered.length) {
                filtered[0].setDisable(!state);
            }
        }

        // Longtouch-Interaktion aktiv/deaktiv
        let interactions = this.map.getInteractions();
        let cnt = interactions.getLength();
        for(let j = 0; j < cnt; j++)
        {
            if (interactions.item(j).get('interaction_type') === 'longtouch')
            {
                if (!state) {
                    interactions.item(j).setActive(false);
                } else {
                    interactions.item(j).setActive(true);
                }
            }
        }
    }


    /**
     * Prüft, ob Bearbeitungselemente verfügbar sind oder nicht (Featurelimit ist erreicht)
     * @private
     */
    private checkFeatureButtonState() {
        if (this.portalkarte.getMaxFeatures() > 0) {
            if (this.portalkarte.countFeatures() >= this.portalkarte.getMaxFeatures()) {
                this.setFeatureButtonState(false);
            } else {
                this.setFeatureButtonState(true);
            }
        }
    }

    /**
     * Beim Setzen eines Punktes mittels LongTouch-Aktion wird ein Puls angedeutet
     * @param map
     * @param coord
     * @private
     */
    private static pulseFeature(map, coord)
    {
        let ol = window["ol"];
        let f = new ol.Feature (new ol.geom.Point(coord));
        f.setStyle (new ol.style.Style(
            {	image: new ol.style.Circle (
                    {	radius: 30,
                        stroke: new ol.style.Stroke ({ color:"red", width:2 })
                    })
            }));
        map.animateFeature (f, new ol.featureAnimation.Zoom(
            {	fade: ol.easing.easeOut,
                duration:800,
                easing: ol.easing.easeOut
            }));
    };

}